<template>
  <v-dialog
    :value="show"
    max-width="700"
    persistent
    @input="$emit('update:show', $event)"
  >
    <v-card>
      <v-card-actions class="justify-end">
        <v-icon
          text
          @click="handleClose"
        >
          mdi-close-thick
        </v-icon>
      </v-card-actions>
      <v-toolbar
        style="background-color:rgb(204 33 40);color:white !important"
        dark
      >
        <strong>Configuración de Alerta - {{ firma.company_name }}</strong>
      </v-toolbar>
      <v-card-text style="padding-top: 20px;">
        <v-form ref="formAlerta">
          <!-- Sección: Activar/Desactivar Alerta -->
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 font-weight-bold mb-2">
                Estado de Alerta
              </div>
              <v-switch
                v-model="alertaConfig.AlertaActiva"
                :label="alertaConfig.AlertaActiva ? 'Alerta Activada' : 'Alerta Desactivada'"
                color="success"
                inset
              />
            </v-col>
          </v-row>

          <v-divider class="my-2" />

          <!-- Sección: Fechas de Vigencia -->
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 font-weight-bold mb-3">
                Vigencia de la Firma
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                :value="firma.valid_from"
                label="Vigencia Desde"
                prepend-inner-icon="mdi-calendar-start"
                disabled
                readonly
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                :value="firma.valid_until"
                label="Vigencia Hasta"
                prepend-inner-icon="mdi-calendar-end"
                disabled
                readonly
                dense
              />
            </v-col>
          </v-row>

          <!-- Sección: Configuración de Notificaciones -->
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 font-weight-bold mb-3">
                Configuración de Notificaciones
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model.number="alertaConfig.DiasVencimientoAlerta"
                label="Alertar cuando falten (Días)"
                prepend-inner-icon="mdi-calendar-alert"
                type="number"
                min="1"
                hint="Días antes del vencimiento para enviar alerta"
                persistent-hint
                :rules="[v => v >= 1 || 'Debe ser mayor a 0']"
                :disabled="!alertaConfig.AlertaActiva"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model.number="alertaConfig.DiasRepetirAlerta"
                label="Repetir alerta cada (Días)"
                prepend-inner-icon="mdi-calendar-refresh"
                type="number"
                min="1"
                hint="Cada cuántos días repetir la alerta"
                persistent-hint
                :rules="[v => v >= 1 || 'Debe ser mayor a 0']"
                :disabled="!alertaConfig.AlertaActiva"
                dense
              />
            </v-col>
            <v-col cols="12"  class="mt-6">
              <v-text-field
                v-model="alertaConfig.CorreoAlerta"
                label="Correo electrónico"
                prepend-inner-icon="mdi-email-alert"
                type="email"
                hint="Correo para recibir las alertas"
                persistent-hint
                :rules="emailRules"
                :disabled="!alertaConfig.AlertaActiva"
                dense
              />
            </v-col>
          </v-row>

          <!-- Alertas y Progress -->
          <v-row v-if="msgResponse">
            <v-col cols="12">
              <v-alert
                :type="alertType"
                text
              >
                {{ msgResponse }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            v-if="progress"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Guardando Configuración
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="handleClose"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          style="background-color:rgb(204 33 40);color:white !important"
          @click="handleSave"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'AlertaFirmaModal',
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      firma: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        alertaConfig: {
          AlertaActiva: false,
          DiasVencimientoAlerta: 30,
          DiasRepetirAlerta: 7,
          CorreoAlerta: '',
        },
        msgResponse: '',
        progress: false,
        alertType: 'success',
        emailRules: [
          v => !this.alertaConfig.AlertaActiva || !!v || 'El correo es requerido cuando la alerta está activa',
          v => !v || /.+@.+\..+/.test(v) || 'El correo debe ser válido',
        ],
      }
    },
    watch: {
      firma: {
        handler (newFirma) {
          if (newFirma && Object.keys(newFirma).length > 0) {
            // Cargar configuración existente si existe
            this.alertaConfig = {
              AlertaActiva: newFirma.alert_active === 1,
              DiasVencimientoAlerta: newFirma.days_expiration_alert || 30,
              DiasRepetirAlerta: newFirma.days_repeat_alert || 7,
              CorreoAlerta: newFirma.alert_email || '',
            }
          }
        },
        deep: true,
        immediate: true,
      },
      show (newVal) {
        if (!newVal) {
          this.msgResponse = ''
          this.progress = false
          this.alertType = 'success'
        }
      },
    },
    methods: {
      handleClose () {
        this.msgResponse = ''
        this.progress = false
        this.alertType = 'success'
        this.$emit('close')
      },
      async handleSave () {
        if (!this.$refs.formAlerta.validate()) {
          return
        }

        this.progress = true
        this.msgResponse = ''
        this.alertType = 'success'

        try {
          const payload = {
            IdFirma: this.firma.id,
            AlertaActiva: this.alertaConfig.AlertaActiva ? 1 : 0,
            DiasVencimientoAlerta: this.alertaConfig.DiasVencimientoAlerta,
            DiasRepetirAlerta: this.alertaConfig.DiasRepetirAlerta,
            CorreoAlerta: this.alertaConfig.CorreoAlerta,
          }

          await this.$store.dispatch('firmas/updateAlertaFirma', payload)

          this.progress = false
          this.alertType = 'success'
          this.msgResponse = 'Configuración de alerta guardada exitosamente'

          setTimeout(() => {
            this.$emit('updated')
            this.handleClose()
          }, 2000)
        } catch (error) {
          this.progress = false
          this.alertType = 'error'
          this.msgResponse = error.message || 'Error al guardar la configuración'
          console.error(error)
        }
      },
    },
  }
</script>

<style scoped>
</style>
